import Slider from './slider';

class Ranger extends Slider {
	start() {
		super.start();
		this.currentChars = this.getChars(0);
		this.events.on('goto', this.updateChars.bind(this));
	}

	updateChars(index) {
		let slide = this.slides[index];
		let data = this.getChars(index);
		this.el.queryAll('.slx-range__data').forEach(item => item.classList.remove('active'));
		slide.queryAll('.slx-range__data').forEach((item) => {
			let key = item.getAttribute('data-char');
			if (data[key] !== this.currentChars[key]) {
				item.classList.add('active');
			}
		});
		this.currentChars = data;
	}

	getChars(index) {
		let slide = this.slides[index];
		return JSON.parse(slide.getAttribute('data-slider-slide'));
	}
}

document.queryAll('.slx-range').forEach((item) => {
	let start = 0;
	const active = item.query('[data-slider-anchor].active');
	if (active) {
		start = Array.prototype.indexOf.call(item.queryAll('[data-slider-anchor]'), active);
	}
	const ranger = new Ranger({
		el: item,
		loop: true,
		start
	});
	ranger.start();
});

export default Ranger;
